
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career",
      function () {
        return require("private-next-pages/career/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career"])
      });
    }
  